import * as actions from './actions'
import * as getters from './getters'

import {
    LOGIN,
    LOGOUT,
    SET_USER
  } from './mutation-types'

const mutations = {
  [LOGIN] (state, authToken) {
    state.authToken = authToken
  },
  [LOGOUT] (state) {
    state.profile = null
    state.authToken = null
  },
  [SET_USER] (state, user) {
    state.profile = user
  }
}

export default {
  state: {
    profile: null,
    authToken: null
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user/index.js